import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { useAppStateStore } from '@/features/application'
import router from '@/router'
import { useVirementStore } from './useVirementStore'

export function useVirementRoutingService() {
  const store = useVirementStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToWithKey(key: any) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    router.push(`/${context}/virement/${key}`)
  }

  function navigateToFactureWithKey(key: any) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    router.push(`/${context}/facture/${key}`)
  }

  function navigateToRechercheVirementsList() {
    if (window.history.state.back) {
      router.go(-1)
    } else {
      const appState = useAppStateStore()
      const context = TypesContextesAutorisesEnum[appState.contextCourant]
      router.push(`/${context}/virements`)
    }
  }

  return { loadStoreWithKey, navigateToWithKey, navigateToFactureWithKey, navigateToRechercheVirementsList }
}

